import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';
import { BrowserRouter as Router } from "react-router-dom";
import { Amplify } from 'aws-amplify';
import awsConfig from './aws-exports';
import { AuthProvider } from './context/AuthContext.tsx';

Amplify.configure(awsConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Router>
      <AuthProvider>
      <App />
      </AuthProvider>
    </Router>
  </React.StrictMode>
);
